import React from 'react';
import { Modal } from 'antd';
import {
  Button,
  ButtonType,
  Input
} from 'syngenta-digital-cropwise-react-ui-kit';
import LayoutStrings from 'screens/Applications&WorkOrders/StepsLayout/Constants/layoutStrings';

const INPUT_WIDTH = '180px';
const INPUT_HEIGHT = '32px';

export interface EditTotalAcreageModalProps {
  open: boolean;
  totalAcresDisplay: string;
  totalCoveragePercent: string;
  onCancel: () => void;
  onSave: () => void;
  onTotalAcresChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onTotalAcresFocus: () => void;
  onTotalAcresBlur: () => void;
  onTotalCoveragePercentChange: (
    e: React.ChangeEvent<HTMLInputElement>
  ) => void;
  onTotalCoveragePercentFocus: () => void;
  onTotalCoveragePercentBlur: () => void;
}

const EditTotalAcreageModal: React.FC<EditTotalAcreageModalProps> = ({
  open,
  totalAcresDisplay,
  totalCoveragePercent,
  onCancel,
  onSave,
  onTotalAcresChange,
  onTotalAcresFocus,
  onTotalAcresBlur,
  onTotalCoveragePercentChange,
  onTotalCoveragePercentFocus,
  onTotalCoveragePercentBlur
}) => (
  <Modal
    open={open}
    onCancel={onCancel}
    footer={null}
    centered
    closable
    width={580}
    transitionName=""
    maskTransitionName=""
    style={{ height: '294px' }}
    styles={{
      body: { height: '100%', display: 'flex', flexDirection: 'column' }
    }}
  >
    <div className="flex flex-col justify-between flex-1">
      <div>
        <div className="text-xl font-semibold leading-7 mt-0">
          {LayoutStrings.cropZones.editModal.title}
        </div>
        <div
          className="mt-2 text-sm font-normal leading-5"
          style={{ color: '#4D5165' }}
        >
          {LayoutStrings.cropZones.editModal.description}
        </div>
      </div>

      <div className="mt-6">
        <div className="flex gap-4">
          <div>
            <label
              htmlFor="totalAcresDisplay"
              className="block text-sm font-normal leading-5 mb-0.5"
              style={{ color: '#696F88' }}
            >
              {LayoutStrings.cropZones.editModal.totalAppliedAcres}
            </label>
            <Input
              id="totalAcresDisplay"
              value={totalAcresDisplay}
              onChange={onTotalAcresChange}
              onFocus={onTotalAcresFocus}
              onBlur={onTotalAcresBlur}
              suffix={<span className="text-neutral-60">ac</span>}
              style={{ width: INPUT_WIDTH, height: INPUT_HEIGHT }}
              autoFocus
            />
          </div>

          <div>
            <label
              htmlFor="totalCoveragePercent"
              className="block text-sm font-normal leading-5 mb-0.5"
              style={{ color: '#696F88' }}
            >
              {LayoutStrings.cropZones.editModal.totalCoveragePercent}
            </label>
            <Input
              id="totalCoveragePercent"
              value={totalCoveragePercent}
              onChange={onTotalCoveragePercentChange}
              onFocus={onTotalCoveragePercentFocus}
              onBlur={onTotalCoveragePercentBlur}
              suffix={<span className="text-neutral-60">%</span>}
              style={{ width: INPUT_WIDTH, height: INPUT_HEIGHT }}
            />
          </div>
        </div>
      </div>

      <div className="flex justify-end gap-2 mt-6 pt-1">
        <Button type={ButtonType.outline} size="large" onClick={onCancel}>
          {LayoutStrings.cropZones.editModal.cancel}
        </Button>
        <Button type={ButtonType.primary} size="large" onClick={onSave}>
          {LayoutStrings.cropZones.editModal.save}
        </Button>
      </div>
    </div>
  </Modal>
);

export default EditTotalAcreageModal;
